@if(showReviewDetails){
<div>
  <div>
    <div>
      <!-- This is info section -->
      <div>
        <div class="align-straight-header">
          <div class="header-width-title">
            <h1>{{ publicProgramData?.programName?.description }}</h1>
          </div>
          <div class="align-test-right">
            <button type="button" class="date-chip" (click)="openOverlay()">
              GENERAL RATE PROVISIONS
              <up-icon name="info" class="icon-style"></up-icon>
            </button>
            <div class="padding-top-download">
              <up-icon
                name="save_alt"
                tabindex="0"
                role="button"
                (click)="downloadDocument()"
                (keydown.enter)="downloadDocument()"
                (keydown.space)="downloadDocument()"
              >
                <up-tooltip>Download Pdf File</up-tooltip>
              </up-icon>
            </div>
          </div>
        </div>
        <!-- All info available -->
        <div class="container-review">
          <div class="align-straight div-top-padding">
            <div class="medium">
              <span class="lane-left-align-stcc">Transload Facility</span
              >&nbsp;&nbsp;
              <span
                >{{ publicProgramData?.transloadVendor?.name }} -
                {{ publicProgramData?.transloadVendor?.city }},
                {{ publicProgramData?.transloadVendor?.state }},
                {{ publicProgramData?.transloadVendor?.country }}
              </span>
            </div>
            <div class="medium">
              <span class="lane-left-align-stcc">STCC</span>&nbsp;&nbsp;
              <span>{{ getStccList }}</span>
            </div>
          </div>
          <div class="align-straight div-top-padding">
            <div class="medium">
              <span class="lane-left-align-date"
                >Effective & Expiration Date</span
              >&nbsp;&nbsp;
              <div class="date-text-width">
                <span class="lane-right-align-date">{{
                  publicProgramData?.rateStartDate | date : 'MM/dd/yyyy'
                }}</span>
                -
                <span class="lane-right-align-date">{{
                  publicProgramData?.rateEndDate | date : 'MM/dd/yyyy'
                }}</span>
              </div>
            </div>
            <div class="medium">
              @if(isLumber()){
              <a
                class="tag-style"
                href="#"
                (click)="
                  openNewTab(
                    'http://www.uprr.com/customers/surcharge/index_mileage.shtml'
                  )
                "
              >
              Rail rates are subject to mileage-based fuel surcharge
              </a>
              }
            </div>
          </div>
        </div>
        <div class="div-top-padding">
          <div class="show-background">
            <span
              >&nbsp;Loup logistics MUST BE LISTED as the SEND FREIGHT party on the
              rail waybill if the rate includes rail. This rate document
              replaces all previous rate quote VERSIONS</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- This is rail section -->
    @if(selectedRailServices){
    <div class="field-padding-overall">
      <div class="custom-accordion">
        <div class="accordion-item expanded">
          <div class="accordion-header-review">
            <span class="left-title header-width">
              <div>
                <span class="span-name">Included Services</span>&nbsp;
                <span class="value-name">{{
                  selectedRailServices | titleCase
                }}</span>
              </div>
            </span>
          </div>
          @if(rows.length > 0){
          <div class="accordion-content">
            <lib-static-dynamic-table-oqms
              [tableHeight]="tableHeight"
              [columns]="columns"
              [rows]="rows"
              (railGroupClick)="railGroupClick($event)"
            ></lib-static-dynamic-table-oqms>
          </div>
          }@else {
          <div class="accordion-content">
            <p class="move-right">No Data Available.</p>
          </div>
          }
        </div>
      </div>
    </div>
    }
    <!-- This is railtruck section -->
    @if(selectedRailTruckServices && railTruckRows.length > 0){
    <div class="field-padding-overall">
      <div class="custom-accordion">
        <div class="accordion-item expanded">
          <div class="accordion-header-review">
            <span class="left-title header-width">
              <div>
                <span class="span-name">Included Services</span>&nbsp;
                <span class="value-name">{{
                  selectedRailTruckServices | titleCase
                }}</span>
              </div>
            </span>
          </div>
          @if(railTruckRows.length > 0){
          <div class="accordion-content">
            <lib-static-dynamic-table-oqms
              [tableHeight]="tableHeight"
              [columns]="railTruckColumns"
              [rows]="railTruckRows"
              (railGroupClick)="railGroupClick($event)"
            ></lib-static-dynamic-table-oqms>
          </div>
          }@else {
          <div class="accordion-content">
            <p class="move-right">No Data Available.</p>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- This is transloadTruck section -->
    @if(selectedTransloadTruckServices && transloadTruckRows.length > 0){
    <div class="field-padding-overall">
      <div class="custom-accordion">
        <div class="accordion-item expanded">
          <div class="accordion-header-review">
            <span class="left-title header-width">
              <div>
                <span class="span-name">Included Services</span>&nbsp;
                <span class="value-name">{{
                  selectedTransloadTruckServices | titleCase
                }}</span>
              </div>
            </span>
          </div>
          @if(transloadTruckRows.length > 0){
          <div class="accordion-content">
            <lib-static-dynamic-table-oqms
              [tableHeight]="tableHeight"
              [columns]="transloadTruckColumns"
              [rows]="transloadTruckRows"
              (railGroupClick)="railGroupClick($event)"
            ></lib-static-dynamic-table-oqms>
          </div>
          }@else {
          <div class="accordion-content">
            <p class="move-right">No Data Available.</p>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- This is transload section -->
    @if(selectedTransloadServices && transloadRows.length > 0){
    <div class="field-padding-overall">
      <div class="custom-accordion">
        <div class="accordion-item expanded">
          <div class="accordion-header-review">
            <span class="left-title header-width">
              <div>
                <span class="span-name">Included Services</span>&nbsp;
                <span class="value-name">{{
                  selectedTransloadServices | titleCase
                }}</span>
              </div>
            </span>
          </div>
          @if(transloadRows.length > 0){
          <div class="accordion-content">
            <lib-static-dynamic-table-oqms
              [tableHeight]="tableHeight"
              [columns]="transloadColumns"
              [rows]="transloadRows"
            ></lib-static-dynamic-table-oqms>
          </div>
          }@else {
          <div class="accordion-content">
            <p class="move-right">No Data Available.</p>
          </div>
          }
        </div>
      </div>
    </div>
    }
    <!-- This is truck section -->
    @if(selectedTruckServices && truckRows.length > 0){
    <div class="field-padding-overall">
      <div class="custom-accordion">
        <div class="accordion-item expanded">
          <div class="accordion-header-review">
            <span class="left-title header-width">
              <div>
                <span class="span-name">Included Services</span>&nbsp;
                <span class="value-name">{{
                  selectedTruckServices | titleCase
                }}</span>
              </div>
            </span>
          </div>
          @if(truckRows.length > 0){
          <div class="accordion-content">
            <lib-static-dynamic-table-oqms
              [tableHeight]="tableHeight"
              [columns]="truckColumns"
              [rows]="truckRows"
            ></lib-static-dynamic-table-oqms>
          </div>
          }@else {
          <div class="accordion-content">
            <p class="move-right">No Data Available.</p>
          </div>
          }
        </div>
      </div>
    </div>
    }
    <!-- This is Storage section -->
    @if(storageRows.length > 0){
    <div class="field-padding-overall">
      <div class="custom-accordion">
        <div class="accordion-item expanded">
          <div class="accordion-header-review">
            <span class="left-title header-width">
              <div>
                <span class="value-name">Storage</span>
              </div>
            </span>
          </div>
          @if(storageRows.length > 0){
          <div class="accordion-content">
            <lib-static-dynamic-table-oqms
              [tableHeight]="tableHeight"
              [columns]="storageColumns"
              [rows]="storageRows"
            ></lib-static-dynamic-table-oqms>
          </div>
          }@else {
          <div class="accordion-content">
            <p class="move-right">No Data Available.</p>
          </div>
          }
        </div>
      </div>
    </div>
    }
    <!-- This is Additional charges section -->
    @if(addidationalChargesRows.length > 0){
    <div class="field-padding-overall">
      <div class="custom-accordion">
        <div class="accordion-item expanded">
          <div class="accordion-header-review">
            <span class="left-title header-width">
              <div>
                <span class="value-name">Value Added Services</span>
              </div>
            </span>
          </div>
          @if(addidationalChargesRows.length > 0){
          <div class="accordion-content">
            <lib-static-dynamic-table-oqms
              [tableHeight]="tableHeight"
              [columns]="addidationalChargesColumns"
              [rows]="addidationalChargesRows"
            ></lib-static-dynamic-table-oqms>
          </div>
          }@else {
          <div class="accordion-content">
            <p class="move-right">No Data Available.</p>
          </div>
          }
        </div>
      </div>
    </div>
    }
    <!-- This is comments section -->
    <div
      class="div-bottom-padding-provisions field-padding-overall"
      *ngIf="commentData"
    >
      <span
        ><span class="header-style" [translate]="'LABEL.COMMENTS'"></span
      ></span>
      <div class="quarter-width text-styling-span">
        {{ commentData || '-' }}
      </div>
    </div>
  </div>
</div>
<div class="space-left-body" *ngIf="showNoDataAvailable">
  <p class="move-right">
    <span [translate]="'LABEL.No Data Available.'"></span>
  </p>
</div>

@if(publicProgramData?.commodityCategory?.description === 'Produce'){
<section class="kv">
  <h3 class="kv__key">Disclaimer</h3>
  <p>
    In line with the Food Safety Modernization Act, the Sanitary Food
    Transportation Act and regulations promulgated under these Acts, customer
    must submit, in writing, any specific handling, storage and/or
    transportation requirements, to ensure that cargo is handled, stored, and
    transported in a safe, proper, and damage-free manner. Such requirements are
    not agreed to by Loup unless Loup confirms its agreement in writing.
  </p>
</section>
} }
<br />

@if(isOverlayOpen){
<lib-rate-provisions-overlay
  [provisionsList]="provisionsList"
  [isExternal]="true"
  [isOverlayOpen]="isOverlayOpen"
  (updateFlagStatus)="closeOverlay()"
></lib-rate-provisions-overlay>
} @if(isTableOverlayOpen){
<lib-location-overlay
  [locationType]="locationType"
  [isTableOverlayOpen]="isTableOverlayOpen"
  [locationColumns]="locationColumns"
  [locationRows]="locationRows"
  (overlayClosed)="closeOverlay()"
></lib-location-overlay>
}
